import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import WebformNumber from '@uncinc/react-drupal-core/dist/Components/Webform/WebformNumber';

import { setCaluclatorLocationsCount } from '../../../../store/actions/UI';

const RiskMonitorWebformNumberField = (data) => {
  const { entity } = data;
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const locationsCountUrlParam = urlParams.get('locations');
  const key = entity.get('#webform_key');

  const onChange = (element) => {
    dispatch(setCaluclatorLocationsCount(parseInt(element.target.value)));
  };

  // Set a default value if the locationsCount was passed in the URLparams.
  useEffect(() => {
    if (locationsCountUrlParam && !data.values[key]) {
      const locationsCount = parseInt(locationsCountUrlParam);
      data.values[key] = locationsCount;
      dispatch(setCaluclatorLocationsCount(locationsCount));
    }
  }, [locationsCountUrlParam, dispatch, key]);

  return (
    <WebformNumber
      {...data}
      key={entity.get('#webform_key')}
      entity={entity}
      onMouseUp={onChange}
      onChange={onChange}
    />
  );
};

export default RiskMonitorWebformNumberField;
